import React from 'react';

import styles from './index.module.scss';

import StatisticFilter from '.';

const TroyStatisticFilter = props => (
  <StatisticFilter {...{ styles, ...props }} />
);

export default TroyStatisticFilter;
